<template>
  <div class="language-switcher">
    <ButtonSecondary
      v-for="language of languages"
      :key="language.label"
      :label="language.label"
      :white="locale !== language.value && largeScreen"
      :black="!largeScreen"
      :class="[{ inactive: locale !== language.value }]"
      @onClick="selectLanguage(language.value)"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
// import { useRoute } from "vue-router";
import useTvaMq from "@/plugins/tvaMq.js";
import { useI18n } from "vue-i18n";

import ButtonSecondary from "./ButtonSecondary.vue";

defineProps({
  languages: {
    type: Array,
    default: () => [],
  },
});

// const router = useRouter();
// const route = useRoute();
const i18n = useI18n();
const { $tvaMq } = useTvaMq();

const largeScreen = computed(() => ["desktop", "large"].includes($tvaMq.value));
const locale = computed(() => i18n.locale.value);

function selectLanguage(newLanguage) {
  if (process.env.NODE_ENV === "development") {
    i18n.locale.value = newLanguage.toLowerCase();
    document
      .querySelector("html")
      .setAttribute("lang", newLanguage.toLowerCase());
  } else {
    const currentLanguage = i18n.locale.value;
    const specificPath = window.location.pathname.replace(
      process.env["VUE_APP_PATH_" + currentLanguage.toUpperCase()],
      ""
    );

    window.location.href =
      process.env["VUE_APP_PATH_" + newLanguage.toUpperCase()] + specificPath;
  }
}
</script>

<style lang="scss" scoped>
.language-switcher {
  width: 100%;

  > :first-child {
    padding-right: 0.5rem;
    border-right: 1px solid var(--white-70);
  }

  > :last-child {
    padding-left: 0.5rem;
  }
  .mobile &,
  .tablet & {
    > :first-child {
      padding-right: 5px;
      border-right: none;
    }

    > :last-child {
      padding-left: 5px;
    }

    .button-secondary {
      text-decoration: underline;
      transition: color 0.3s ease;
    }
    .inactive {
      color: var(--scala-grigi-gray-3);
      text-decoration: none;
    }
  }
}
</style>
